var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-icon',{staticClass:"mr-5"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(_vm._s(_vm.icon))])],1),_c('v-list-item-content',{staticClass:"mr-0"},[_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.label))]),_c('v-list-item-title',{domProps:{"innerHTML":_vm._s(_vm.value)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }